module.exports = __webpack_public_path__ + "img/download-app-store.505e2f73.png";